require('./composite_property.html');
require('./simple_property.html');
